// extracted by mini-css-extract-plugin
export var infoRow = "_sk-2";
export var labelContainer = "_sk-0";
export var rightInfo = "_sk-1";